import { render } from "./button-base.vue?vue&type=template&id=56f8ab8c&scoped=true"
import script from "./button-base.vue?vue&type=script&lang=js"
export * from "./button-base.vue?vue&type=script&lang=js"

import "./button-base.vue?vue&type=style&index=0&id=56f8ab8c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f8ab8c"]])

export default __exports__